var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklistInactiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15C13.8801 14.9984 14.9984 13.8801 15 12.5V2.50001C14.9984 1.11994 13.8801 0.00159469 12.5 0H2.50001C1.11994 0.00159469 0.00159469 1.11994 0 2.50001V12.5C0.00159469 13.8801 1.11994 14.9984 2.50001 15L12.5 15ZM1.24999 12.5V2.50001C1.25066 1.80993 1.80993 1.25068 2.49999 1.25002H12.5C13.1901 1.25068 13.7493 1.80995 13.75 2.50001V12.5C13.7493 13.1901 13.19 13.7493 12.5 13.75H2.50001C1.80993 13.7493 1.25068 13.1901 1.24999 12.5Z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37501 11.875C4.54081 11.8752 4.69983 11.8093 4.81691 11.6919L7.31692 9.19191C7.55789 8.94476 7.55286 8.54905 7.30571 8.30811C7.06297 8.07145 6.67585 8.07145 6.43312 8.30811L4.37503 10.3662L3.56694 9.55812C3.31979 9.31715 2.92408 9.32218 2.68314 9.56934C2.44648 9.81207 2.44648 10.1992 2.68314 10.442L3.93313 11.6919C4.05018 11.8093 4.20921 11.8752 4.37501 11.875Z",
    fill: "#353535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.37501 6.87502C4.54081 6.87521 4.69984 6.80931 4.81691 6.69192L7.31692 4.19191C7.56408 3.95094 7.56908 3.55526 7.32814 3.3081C7.08717 3.06095 6.69149 3.05595 6.44433 3.29689C6.44055 3.30057 6.43683 3.30433 6.43312 3.3081L4.37503 5.36624L3.56694 4.55812C3.32597 4.31097 2.93029 4.30597 2.68314 4.54691C2.43599 4.78788 2.43098 5.18356 2.67193 5.43071C2.67561 5.43449 2.67936 5.43822 2.68314 5.44193L3.93313 6.69192C4.05018 6.80931 4.20921 6.87519 4.37501 6.87502Z",
    fill: "#353535"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 11.25C12.2202 11.25 12.5 10.9702 12.5 10.625C12.5 10.2799 12.2202 10 11.875 10H8.75C8.40481 10 8.125 10.2799 8.125 10.625C8.125 10.9702 8.40483 11.25 8.75 11.25H11.875Z",
    fill: "#353535"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 6.24999C12.2202 6.24999 12.5 5.97016 12.5 5.625C12.5 5.27983 12.2202 5 11.875 5H8.75C8.40481 5 8.125 5.27983 8.125 5.625C8.125 5.97016 8.40483 6.24999 8.75 6.24999H11.875Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistInactiveIcon);
export default __webpack_public_path__ + "static/media/checklist-inactive-icon.5798faa3f3fc4b02e84dc83a6ce088e2.svg";
export { ForwardRef as ReactComponent };